import Lenis from "lenis";

let lenis = null;

export const initLenis = () => {
  if (lenis || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return () => {};
  lenis = new Lenis({ duration: 1.25, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) });
  let id;
  const raf = (time) => { lenis.raf(time); id = requestAnimationFrame(raf); };
  id = requestAnimationFrame(raf);
  return () => { cancelAnimationFrame(id); lenis.destroy(); lenis = null; };
};

export const scrollToId = (id) => {
  const el = id ? document.getElementById(id) : null;
  if (lenis) lenis.scrollTo(el || 0, { offset: el ? -72 : 0 });
  else if (el) el.scrollIntoView({ behavior: "smooth" });
  else window.scrollTo({ top: 0, behavior: "smooth" });
};

export const scrollTop = () => {
  if (lenis) lenis.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
};
